import React, { useState, useEffect } from 'react';
import { calculateTimeLeft } from '../../../../utils/raceTime';
import { padNumber } from '../../../../utils/padNumber';
import { RaceStatus } from '../../../../types/race';

import './RaceTimer.css';

type RaceTimerProps = {
  raceEndTime: bigint;
  status: RaceStatus;
};

const RaceTimer = ({ raceEndTime, status }: RaceTimerProps) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(raceEndTime));

  // Update timer every second
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(raceEndTime));
    }, 1000);

    return () => clearInterval(timer);
  }, [raceEndTime]);

  return (
    <div className="flex gap-16">
      <div className="flex-1 text-lg font-bold">
        {status === RaceStatus.CONCLUDED ? 'Final Standings' : 'Live Standings'}
      </div>
      <div className="flex flex-[3] flex-col gap-3">
        <div className="timer-label">Time Remaining</div>
        {status === RaceStatus.CONCLUDED ? (
          <div className="text-xl font-bold leading-6">Ended</div>
        ) : (
          <div className="horizontal-timer">
            <div className="time-unit">
              <span className="time-value">{padNumber(timeLeft.hours)}</span>
              <span className="time-label">Hrs</span>
            </div>
            <div className="time-unit">
              <span className="time-value">{padNumber(timeLeft.minutes)}</span>
              <span className="time-label">Mins</span>
            </div>
            <div className="time-unit">
              <span className="time-value">{padNumber(timeLeft.seconds)}</span>
              <span className="time-label">Secs</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RaceTimer;
